var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading||_vm.isAppLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"h-100 row m-auto"},[(_vm.isLoading)?_c('div',{staticClass:"m-auto"},[_vm._v("\n            Loading...\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isLoading&&_vm.isAppLoading)?_c('div',{staticClass:"m-auto"},[_vm._v("\n            Getting data...\n        ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175465df","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = xqmF
// module chunks = 1